import { useSyncExternalStore } from 'react';
import { getRunnerUiSnapshot, subscribeRunnerUi } from '../../state/runnerUiStore.ts';
import { RUNNER_DOM } from './runnerDomIds.ts';

export function RunnerGameOver() {
  const d = RUNNER_DOM;
  const s = useSyncExternalStore(subscribeRunnerUi, getRunnerUiSnapshot, getRunnerUiSnapshot);

  return (
    <div id={d.gameOverRoot} className="runner-gameover" hidden={!s.gameOverVisible}>
      <h2 className="runner-gameover__title">Game Over</h2>
      <div className="runner-gameover__score">Score: {s.score}</div>
    </div>
  );
}
